import { createSelector } from 'reselect';

const selectAssistancePrograms = (state: any) => state.assistancePrograms;

export const selectAssistanceProgramsCurrentItem = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.current);

export const selectAssistanceProgramsListItems = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.list);


export const selectAssistanceProgramsItemById = (itemId: any) =>
    createSelector(selectAssistanceProgramsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAssistanceProgramsCreatedItem = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.create);

export const selectAssistanceProgramsUpdatedItem = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.update);

export const selectAssistanceProgramsReadItem = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.read);

export const selectAssistanceProgramsDeletedItem = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.delete);

export const selectAssistanceProgramsSearchedItems = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.search);

export const selectAssistanceProgramsItemsCount = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.count);

export const selectAssistanceProgramsItemsFilter = createSelector([selectAssistancePrograms], (assistancePrograms) => assistancePrograms.filter);